type AdminClaimUser =
  | {
      app_metadata?: unknown;
    }
  | null
  | undefined;

/** The trusted app_metadata claim is the sole client-side admin signal. */
export function hasTrustedAdminClaim(user: AdminClaimUser): boolean {
  const metadata = user?.app_metadata;
  return (
    typeof metadata === 'object' &&
    metadata !== null &&
    'plotwise_admin' in metadata &&
    metadata.plotwise_admin === true
  );
}
